import Vue from 'vue';
import i18n from '@/i18n/index';
import ViewUI from 'view-design';
import vComponents from '@/components/v-components/index';
import ECharts from 'vue-echarts';
import SvgPanZoom from 'vue-svg-pan-zoom';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router/router';
import store from './store';
import '@/utils/permission';
import '@/utils/filter';
import '@/customTheme/dist/iview.css';
// import '@/customTheme/custom.less';
// import 'view-design/dist/styles/iview.css';
import rules from './utils/rules';
import '@/utils/handleGoTo';

Vue.config.productionTip = false;
// 切换页面需要取消未完成的请求
Vue.prototype.cancelList = [];
Vue.prototype.$rules = rules;
Vue.use(ViewUI, {
  select: {
    arrow: 'md-arrow-dropdown',
  },
});
Vue.use(vComponents);
Vue.component('v-chart', ECharts);
Vue.component('SvgPanZoom', SvgPanZoom);
Vue.use(VueCookies);

// get token and userinfo from cookies and cache
if (VueCookies.isKey('token')) {
  store.commit('updateState', {
    token: VueCookies.get('token'),
  });
  if (localStorage.getItem('user_info')) store.commit('user/updateState', JSON.parse(localStorage.getItem('user_info')));
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
